module.exports = __webpack_public_path__ + "media/images/resell-67c68e0fafb47b95531ff59691c494c1.png";